import React from "react";
import { useSearchParams } from "react-router";
import CustomersTable from "./CustomersTable";
import UsersTable from "./UsersTable";
import SalesforceOrgsTable from "./SalesforceOrgsTable";
import QueueTable from "../ManageQueue/QueueTable";

export default function Customers() {
    const [searchParams, setSearchParams] = useSearchParams();
    const view = searchParams.get("view"); // users | salesforce | queues | null
    const tenantId = searchParams.get("tenantId");

    const backToCustomers = () => {
        // eslint-disable-next-line no-undef
        const sp = new URLSearchParams();
        sp.set("page", "manageCustomers");
        setSearchParams(sp);
    };

    //  MAIN LOGIC
    if (view === "users" && tenantId) {
        return (
            <UsersTable
                tenantId={tenantId}
                onBack={backToCustomers}
            />
        );
    }
    if (view === "salesforce" && tenantId) {
        return (
            <SalesforceOrgsTable
                tenantId={tenantId}
                onBack={backToCustomers}
            />
        );
    }
    if (view === "queues" && tenantId) {
        return (
            <QueueTable
                searchTenantId={tenantId}
                onBack={backToCustomers}
            />
        );
    }
    // Default → Customers List
    return (
        <CustomersTable
            onNavigate={(type, tenant) => {
                // eslint-disable-next-line no-undef
                const sp = new URLSearchParams();
                sp.set("page", "manageCustomers");
                sp.set("tenantId", tenant?.tenantId);
                if (type === "users") {
                    sp.set("view", "users");
                } else if (type === "salesforce") {
                    sp.set("view", "salesforce");
                } else if (type === "queues") {
                    sp.set("view", "queues");
                }
                setSearchParams(sp);
            }}
        />
    );
}
